import modalShiftFormUrl from './modal-shift-form.html';

export default function shiftForm() {
  return {
    templateUrl: modalShiftFormUrl,
    controllerProvider: async () =>
      (await import(/* webpackChunkName: "shifts" */ '../EditShiftCtrl')).default,
    controllerAs: 'ctrl',
    scope: {
      shift: '=',
      modal: '=',
      isTemplate: '<',
      shiftShouldPublish: '=?',
      fieldsVisibilityOptions: '<?',
      fieldsVisibilityDisabled: '<?',
    },
  };
}
